export const estilos = {
  page: {
    padding: 5,
    paddingTop: 75,
    paddingBottom: 65
  },
  pageBackground: {
    position: 'absolute',
    minWidth: '100%',
    minHeight: '100%',
    display: 'block',
    height: '100%',
    width: '100%'
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1
  },
  details: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 10,
    marginLeft: 5,
    borderBottom: 0.5,
    paddingHorizontal: 2
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: 5,
    marginLeft: 10
  },
  titlePrincipal: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
    padding: 5,
    marginLeft: 10
  },
  subtitleIzq: {
    flex: 6,
    fontSize: 12,
    textAlign: 'left',
    padding: 5,
    paddingBottom: 5,
    marginLeft: 10,
    marginHorizontal: 10
  },
  subtitleDer: {
    flex: 1,
    fontSize: 12,
    textAlign: 'right',
    padding: 5,
    paddingBottom: 5
  },
  total: {
    fontSize: 12,
    textAlign: 'right',
    fontWeight: 'bold',
    right: 25,
    padding: 2,
    paddingTop: 10
  },
  leyenda: {
    flex: 6,
    fontSize: 10,
    textAlign: 'left',
    padding: 5,
    marginLeft: 5,
    marginHorizontal: 5
  },
  pop: {
    fontSize: 10,
    padding: 2,
    backgroundColor: '#61C74F',
    color: '#fff'
  },
  overviewContainer: {
    minHeight: 30,
    flexGrow: 1
  },
  logo: {
    position: 'absolute',
    display: 'block',
    top: 15,
    left: 15,
    width: '96%'
  },
  footerLogo: {
    position: 'absolute',
    fontSize: 12,
    bottom: 25,
    left: 35,
    right: 0,
    height: 30,
    width: 130,
    marginHorizontal: 190
  },
  footer: {
    position: 'absolute',
    fontSize: 12,
    bottom: 25,
    left: 35,
    right: 0,
    textAlign: 'left',
    color: 'grey'
  },
  version: {
    position: 'absolute',
    fontSize: 12,
    bottom: 25,
    left: 0,
    right: 45,
    textAlign: 'right',
    color: 'grey'
  },
  table:
    {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid'
    },
  tableRow:
    {
      margin: 'auto',
      flexDirection: 'row',
      backgroundColor: '#fff'
    },
  tableCol:
    {
      width: '10%',
      borderStyle: 'solid',
      borderColor: '#bfbfbf',
      borderBottom: 1
    },
  tableTituloCell:
    {
      margin: 'auto',
      marginTop: 2,
      marginBottom: 2,
      fontSize: 10,
      fontWeight: 'bold',
      color: '#fff'
    },
  tableCell:
    {
      margin: 'auto',
      marginTop: 5,
      marginBottom: 5,
      fontWeight: 'bold',
      fontSize: 14
    }
}
